import request from '@/utils/request'
import type { ApiResponse } from '@/utils/request'

export interface LoginParams {
  username: string
  password: string
}

export interface UserInfo {
  id: number
  username: string
  email: string
  is_upload: boolean | number
  is_look: boolean | number
  is_admin: boolean
  is_active: boolean
  ai_advanced_permission: boolean | number
}

export interface LoginResponse {
  access_token: string
  user: UserInfo
}

export const login = (data: LoginParams): Promise<ApiResponse<LoginResponse>> => {
  return request.post('/auth/login', data)
}

export const logout = (): Promise<ApiResponse<void>> => {
  return request.post('/auth/logout')
}

// 获取当前用户信息
export const getCurrentUser = (): Promise<ApiResponse<UserInfo>> => {
  return request.get('/auth/me')
}

// 修改密码
export interface ChangePasswordParams {
  old_password: string
  new_password: string
}

export const changePassword = (data: ChangePasswordParams): Promise<ApiResponse<void>> => {
  return request.put('/users/change-password', data)
}

// 重置密码
export interface ResetPasswordParams {
  password: string
}

export const resetPassword = (userId: number, data: ResetPasswordParams): Promise<ApiResponse<void>> => {
  return request.put(`/users/${userId}/password`, data)
}